import { render, staticRenderFns } from "./channel-options.vue?vue&type=template&id=53eed59e&scoped=true&"
import script from "./channel-options.vue?vue&type=script&lang=js&"
export * from "./channel-options.vue?vue&type=script&lang=js&"
import style0 from "./channel-options.vue?vue&type=style&index=0&id=53eed59e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eed59e",
  null
  
)

export default component.exports